<template>
  <div class="page profile-page">
    <div class="profile-hero">
      <div>
        <div class="section-kicker">USER CENTER</div>
        <h1>我的服务中心</h1>
        <p>在线客服，协议管理，设备更换，达标申诉。</p>
      </div>
      <div class="profile-actions">
        <button
          class="btn light"
          @click="$router.push('/login')"
          v-if="!loggedIn"
        >
          登录
        </button>
        <button class="btn light danger-light" @click="logout" v-else>
          退出登录
        </button>
      </div>
    </div>

    <div class="profile-grid">
      <div class="card upload-card">
        <div class="section-kicker">OFFLINE PROOF</div>
        <h3>上传用户签字告知单的照片</h3>
        <p class="muted">上传用户签字告知单的照片，线上合同+线下告知单。</p>
        <label class="upload-box">
          <input type="file" accept="image/*" @change="upload" />
          <span>{{ uploading ? "正在上传…" : "点击选择照片上传" }}</span>
        </label>
        <div class="photo-list" v-if="photos.length">
          <a v-for="x in photos" :key="x.id" :href="x.photo_url" target="_blank"
            ><img :src="x.photo_url" alt="用户签字告知单" /><span>{{
              x.uploaded_at
            }}</span></a
          >
        </div>
        <p class="muted" v-else>尚未上传告知单照片</p>
      </div>
      <div class="card">
        <div class="section-kicker">SERVICE MENU</div>
        <h3>功能菜单</h3>
        <div class="profile-menu">
          <button @click="$router.push('/bind-device')">机具绑定</button>
          <button @click="$router.push('/bind-device?mode=replace')">
            更换设备
          </button>
          <button @click="$router.push('/calendar')">在线记录</button>
          <button @click="$router.push('/simple-agreement')">我的协议</button>
          <button @click="$router.push('/formal-agreements')">
            电子协议（PDF）
          </button>
        </div>
      </div>

      <div class="card contact-card">
        <div class="section-kicker">CONTACT</div>
        <h3>客服联系方式</h3>
        <p class="service-hours">客服工作时间：周一—周五，早上9:00—18:00</p>
        <div class="contact-row" @click="showQr = true">
          <div class="contact-icon">微</div>
          <div><span>在线客服</span><b>点击查看客服微信二维码</b></div>
          <a href="javascript:;">查看</a>
        </div>
        <div class="contact-row">
          <div class="contact-icon">☎</div>
          <div>
            <span>客服电话</span><b>{{ phones.customer || "后台未配置" }}</b>
          </div>
          <a v-if="phones.customer" :href="'tel:' + phones.customer">拨打</a>
        </div>
        <div class="contact-row danger">
          <div class="contact-icon">!</div>
          <div>
            <span>投诉电话</span><b>{{ phones.complaint || "后台未配置" }}</b>
          </div>
          <a v-if="phones.complaint" :href="'tel:' + phones.complaint">拨打</a>
        </div>
      </div>

      <div class="card appeal-card">
        <div class="section-kicker">APPEAL</div>
        <h3>客户申诉</h3>
        <p class="muted">
          如当月设备异常离线，可提交申诉，后台人工复核后可补达标。
        </p>
        <div class="form-stack">
          <input v-model="month" placeholder="考核月份 YYYY-MM" />
          <textarea
            v-model="reason"
            placeholder="请描述异常离线情况，例如断电、运营商网络异常、设备状态异常等"
          ></textarea>
          <button class="btn submit-btn" @click="appeal">提交申诉</button>
        </div>
      </div>
    </div>
    <div class="qr-mask" v-if="showQr" @click="showQr = false">
      <div class="qr-dialog" @click.stop>
        <h3>客服微信二维码</h3>
        <img v-if="phones.qr" :src="phones.qr" alt="客服微信二维码" />
        <p v-else class="muted">后台暂未配置客服微信二维码</p>
        <button class="btn" @click="showQr = false">关闭</button>
      </div>
    </div>
  </div>
</template>
<script>
import { api, getUserId, hasLogin, clearLogin } from "../api";
export default {
  data: () => ({
    month: "",
    reason: "",
    sn: localStorage.getItem("deviceSn") || "",
    photos: [],
    uploading: false,
    simpleAgreement: {},
    phones: { customer: "", complaint: "", qr: "" },
    showQr: false,
    loggedIn: hasLogin(),
  }),
  async created() {
    const userId = getUserId();
    const [homeRes, contentRes, photoRes, siteRes] = await Promise.all([
      api.get("/h5/home", { params: { userId } }).catch(() => ({ data: { data: {} } })),
      api.get("/h5/content-config").catch(() => ({ data: { data: [] } })),
      api.get("/h5/notice-photos").catch(() => ({ data: { data: [] } })),
      api.get("/h5/site-config"),
    ]);
    const home = homeRes.data.data || {};
    const siteConfig = Object.assign(
      {},
      home.siteConfig || {},
      siteRes.data.data || {}
    );
    this.sn = (home.device && home.device.sn) || "";
    if (this.sn) localStorage.setItem("deviceSn", this.sn);
    this.phones.customer =
      siteConfig["site.customer_service_phone"] ||
      siteConfig.customerServicePhone ||
      this.phones.customer;
    this.phones.complaint =
      siteConfig["site.complaint_phone"] ||
      siteConfig.complaintPhone ||
      this.phones.complaint;
    this.phones.qr =
      siteConfig["site.customer_service_qr"] ||
      siteConfig.customerServiceQr ||
      "";
    this.photos = photoRes.data.data || [];
    this.simpleAgreement =
      (contentRes.data.data || []).find(
        (x) => x.config_key === "simple_agreement"
      ) || {};
  },
  methods: {
    logout() {
      clearLogin();
      this.loggedIn = false;
      alert("已退出登录");
    },
    async upload(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (!this.sn) {
        alert("请先完成签约支付并绑定设备");
        return;
      }
      this.uploading = true;
      try {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(
          `/h5/notice-photo?sn=${encodeURIComponent(this.sn)}`,
          fd
        );
        this.photos = (await api.get("/h5/notice-photos")).data.data || [];
        alert("照片上传成功");
      } catch (err) {
        alert(
          (err.response && err.response.data && err.response.data.message) ||
            "照片上传失败"
        );
      } finally {
        this.uploading = false;
        e.target.value = "";
      }
    },
    async appeal() {
      if (!this.sn) {
        alert("请先绑定设备SN");
        return;
      }
      await api.post("/h5/appeal", {
        deviceSn: this.sn,
        assessMonth: this.month,
        reason: this.reason,
      });
      alert("已提交");
    },
  },
};
</script>
<style scoped>
.profile-hero {
  background: linear-gradient(135deg, #123d30, #16b873);
  color: #fff;
  border-radius: 28px;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  box-shadow: 0 24px 60px rgba(15, 118, 77, 0.22);
  position: relative;
  overflow: hidden;
}
.profile-hero:after {
  content: "";
  position: absolute;
  right: -60px;
  top: -70px;
  width: 210px;
  height: 210px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  animation: floatHalo 5s ease-in-out infinite;
}
.profile-hero > * {
  position: relative;
  z-index: 1;
}
.profile-hero h1 {
  margin: 6px 0 8px;
  font-size: 34px;
}
.profile-hero p {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
}
.profile-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.light {
  background: #fff;
  color: #0e8d59;
}
.danger-light {
  color: #d84232;
}
.profile-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.profile-menu {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}
.profile-menu button {
  background: #f1fbf6;
  border: 1px solid #d8f1e6;
  border-radius: 16px;
  padding: 16px;
  color: #17563e;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  transition: 0.2s;
  cursor: pointer;
}
.profile-menu button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(15, 118, 77, 0.1);
}
.upload-card {
  grid-column: 1/-1;
}
.simple-rule {
  grid-column: 1/-1;
}
.simple-rule .rich-content {
  color: #52645c;
  line-height: 1.8;
}
.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #19a96d;
  background: linear-gradient(135deg, #f3fbf7, #fff);
  border-radius: 18px;
  min-height: 126px;
  color: #0f8755;
  font-weight: 800;
  cursor: pointer;
  transition: 0.2s;
}
.upload-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(15, 118, 77, 0.12);
}
.upload-box input {
  display: none;
}
.photo-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}
.photo-list a {
  display: block;
  text-decoration: none;
  color: #718079;
  background: #f5faf7;
  border-radius: 12px;
  padding: 7px;
}
.photo-list img {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 9px;
}
.photo-list span {
  display: block;
  font-size: 11px;
  margin-top: 6px;
  text-align: center;
}
.contact-card {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.94),
    rgba(246, 253, 249, 0.9)
  );
}
.service-hours {
  margin: 4px 0 14px;
  color: #667873;
  font-size: 14px;
}
.contact-row {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  background: #fff;
  border: 1px solid #edf4f0;
  border-radius: 18px;
  padding: 14px;
  margin: 12px 0;
  box-shadow: 0 10px 24px rgba(20, 72, 53, 0.06);
  transition: 0.2s;
}
.contact-row:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(20, 72, 53, 0.1);
}
.contact-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9fbf2;
  color: #0b935a;
  font-weight: 900;
  font-size: 20px;
}
.contact-row.danger .contact-icon {
  background: #fff1ef;
  color: #d84232;
}
.contact-row span {
  display: block;
  color: #77827f;
  font-size: 12px;
  margin-bottom: 3px;
}
.contact-row b {
  font-size: 18px;
}
.contact-row a {
  color: #fff;
  background: #0fa665;
  border-radius: 999px;
  padding: 8px 14px;
  text-decoration: none;
  font-weight: 800;
}
.appeal-card {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.94),
    rgba(250, 252, 251, 0.94)
  );
}
.form-stack {
  display: grid;
  gap: 12px;
}
.submit-btn {
  justify-self: start;
  min-width: 128px;
}
.qr-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.48);
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.qr-dialog {
  width: min(360px, 100%);
  background: #fff;
  border-radius: 22px;
  padding: 22px;
  text-align: center;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.2);
}
.qr-dialog img {
  display: block;
  width: 240px;
  max-width: 100%;
  margin: 12px auto;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(23, 53, 43, 0.12);
}
@keyframes floatHalo {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-12px, 10px);
  }
}
@media (max-width: 768px) {
  .profile-hero {
    padding: 20px;
    border-radius: 20px;
    display: block;
  }
  .profile-hero h1 {
    font-size: 24px;
  }
  .profile-actions {
    justify-content: flex-start;
    margin-top: 14px;
  }
  .profile-actions .btn {
    flex: 1;
  }
  .profile-grid {
    display: block;
  }
  .profile-menu {
    grid-template-columns: 1fr;
  }
  .profile-menu button {
    font-size: 16px;
    padding: 14px;
  }
  .photo-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .photo-list img {
    height: 105px;
  }
  .contact-row {
    grid-template-columns: 42px minmax(0, 1fr);
    padding: 12px;
  }
  .contact-row a {
    grid-column: 1 / -1;
    text-align: center;
  }
  .submit-btn {
    width: 100%;
  }
}
</style>
